import { render, staticRenderFns } from "./ConnectMccAccountBtn.vue?vue&type=template&id=31cb88d8&"
import script from "./ConnectMccAccountBtn.vue?vue&type=script&lang=js&"
export * from "./ConnectMccAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports